import { Injectable } from '@angular/core';
import { Roles, User } from './../model';

const LOCAL_USER = 'localUser';

@Injectable()
export class UserStorage {
  constructor() {}

  public signOut() {
    localStorage.removeItem(LOCAL_USER);
    localStorage.clear();
  }

  public saveLocalUser(user: User) {
    localStorage.removeItem(LOCAL_USER);
    localStorage.setItem(LOCAL_USER, JSON.stringify(user));
  }

  public getLocalUser(): string {
    return localStorage.getItem(LOCAL_USER);
  }

  public getLocalUserRole(): number {
    let user: any = localStorage.getItem(LOCAL_USER);
    user = JSON.parse(user);
    if (user) {
      return user.role;
    } else {
      return Roles.Unknown;
    }
  }

  public getLocalUserName(): string {
    let user: any = localStorage.getItem(LOCAL_USER);
    user = JSON.parse(user);
    if (user) {
      return user.firstName + ' ' + user.lastName;
    } else {
      return '';
    }
  }

  public getLocalUserID(): string {
    let user: any = localStorage.getItem(LOCAL_USER);
    user = JSON.parse(user);
    if (user) {
      return user.id;
    } else {
      return '0';
    }
  }

  public getLocalUserEmail(): string {
    let user: any = localStorage.getItem(LOCAL_USER);
    user = JSON.parse(user);
    if (user) {
      return user.email;
    } else {
      return '';
    }
  }

  public isAdmin(): boolean {
    let user: any = localStorage.getItem(LOCAL_USER);
    user = JSON.parse(user);
    if (user) {
      return (user.role === Roles.Admin ? true : false ) ;
    } else {
      return false;
    }
  }
  public isEngineer(): boolean {
    let user: any = localStorage.getItem(LOCAL_USER);
    user = JSON.parse(user);
    if (user) {
      return (user.role === Roles.Engineer ? true : false ) ;
    } else {
      return false;
    }
  }
  public isTechnician(): boolean {
    let user: any = localStorage.getItem(LOCAL_USER);
    user = JSON.parse(user);
    if (user) {
      return (user.role === Roles.Technician ? true : false ) ;
    } else {
      return false;
    }
  }


}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/helper/userStorage.ts